module.exports = __webpack_public_path__ + "static/media/S2N14-5.064b65db.svg";